export const HEADING =
    "text-[40px] lg:text-7xl leading-[69.4px] lg:leading-loose font-bold self-center";
